/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateGeneticsReportRequestDto,
  DeleteGeneticsReportsRequestDto,
  ErrorResponse,
  GeneticsReportResponseDto,
  GeneticsReportsListResponseDto,
  MarkNotificationAsRead200Response,
  UpdateGeneticsReportRequestDto,
} from '../models/index';
import {
    CreateGeneticsReportRequestDtoFromJSON,
    CreateGeneticsReportRequestDtoToJSON,
    DeleteGeneticsReportsRequestDtoFromJSON,
    DeleteGeneticsReportsRequestDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GeneticsReportResponseDtoFromJSON,
    GeneticsReportResponseDtoToJSON,
    GeneticsReportsListResponseDtoFromJSON,
    GeneticsReportsListResponseDtoToJSON,
    MarkNotificationAsRead200ResponseFromJSON,
    MarkNotificationAsRead200ResponseToJSON,
    UpdateGeneticsReportRequestDtoFromJSON,
    UpdateGeneticsReportRequestDtoToJSON,
} from '../models/index';

export interface CreateGeneticsReportRequest {
    createGeneticsReportRequestDto: CreateGeneticsReportRequestDto;
}

export interface DeleteGeneticsReportRequest {
    deleteGeneticsReportsRequestDto: DeleteGeneticsReportsRequestDto;
}

export interface DeleteGeneticsReportForProviderRequest {
    reportId: string;
}

export interface GetGeneticsReportsByPatientRequest {
    search?: string;
    sortBy?: GetGeneticsReportsByPatientSortByEnum;
    orderBy?: GetGeneticsReportsByPatientOrderByEnum;
    fileType?: GetGeneticsReportsByPatientFileTypeEnum;
    uploadDateFrom?: Date;
    uploadDateTo?: Date;
    page?: number;
    limit?: number;
}

export interface GetGeneticsReportsByPatientIdRequest {
    patientId: string;
    search?: string;
    sortBy?: GetGeneticsReportsByPatientIdSortByEnum;
    orderBy?: GetGeneticsReportsByPatientIdOrderByEnum;
    fileType?: GetGeneticsReportsByPatientIdFileTypeEnum;
    uploadDateFrom?: Date;
    uploadDateTo?: Date;
    page?: number;
    limit?: number;
}

export interface UpdateDiagnosticForProviderRequest {
    patientId: string;
    reportId: string;
    updateGeneticsReportRequestDto: UpdateGeneticsReportRequestDto;
}

export interface UpdateGeneticsReportRequest {
    id: string;
    updateGeneticsReportRequestDto: UpdateGeneticsReportRequestDto;
}

export interface UploadGeneticsReportRequest {
    patientId: string;
    createGeneticsReportRequestDto: Array<CreateGeneticsReportRequestDto>;
}

/**
 * 
 */
export class PatientGeneticsReportsApi extends runtime.BaseAPI {

    /**
     * Creates a new genetics report record with file metadata
     * Create a new genetics report
     */
    async createGeneticsReportRaw(requestParameters: CreateGeneticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneticsReportResponseDto>> {
        if (requestParameters['createGeneticsReportRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createGeneticsReportRequestDto',
                'Required parameter "createGeneticsReportRequestDto" was null or undefined when calling createGeneticsReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/genetics-reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGeneticsReportRequestDtoToJSON(requestParameters['createGeneticsReportRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneticsReportResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new genetics report record with file metadata
     * Create a new genetics report
     */
    async createGeneticsReport(requestParameters: CreateGeneticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneticsReportResponseDto> {
        const response = await this.createGeneticsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft deletes multiple genetics reports by providing an array of IDs
     * Delete multiple genetics reports (soft delete)
     */
    async deleteGeneticsReportRaw(requestParameters: DeleteGeneticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkNotificationAsRead200Response>> {
        if (requestParameters['deleteGeneticsReportsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'deleteGeneticsReportsRequestDto',
                'Required parameter "deleteGeneticsReportsRequestDto" was null or undefined when calling deleteGeneticsReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/genetics-reports`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteGeneticsReportsRequestDtoToJSON(requestParameters['deleteGeneticsReportsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkNotificationAsRead200ResponseFromJSON(jsonValue));
    }

    /**
     * Soft deletes multiple genetics reports by providing an array of IDs
     * Delete multiple genetics reports (soft delete)
     */
    async deleteGeneticsReport(requestParameters: DeleteGeneticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkNotificationAsRead200Response> {
        const response = await this.deleteGeneticsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a genetics report for a provider
     * Delete a genetics report for a provider
     */
    async deleteGeneticsReportForProviderRaw(requestParameters: DeleteGeneticsReportForProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkNotificationAsRead200Response>> {
        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling deleteGeneticsReportForProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/genetics-reports/{reportId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkNotificationAsRead200ResponseFromJSON(jsonValue));
    }

    /**
     * Deletes a genetics report for a provider
     * Delete a genetics report for a provider
     */
    async deleteGeneticsReportForProvider(requestParameters: DeleteGeneticsReportForProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkNotificationAsRead200Response> {
        const response = await this.deleteGeneticsReportForProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves genetics reports for a patient with search, sort, and filter capabilities
     * Get genetics reports by patient with search, sort, and filter
     */
    async getGeneticsReportsByPatientRaw(requestParameters: GetGeneticsReportsByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneticsReportsListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['fileType'] != null) {
            queryParameters['fileType'] = requestParameters['fileType'];
        }

        if (requestParameters['uploadDateFrom'] != null) {
            queryParameters['uploadDateFrom'] = (requestParameters['uploadDateFrom'] as any).toISOString();
        }

        if (requestParameters['uploadDateTo'] != null) {
            queryParameters['uploadDateTo'] = (requestParameters['uploadDateTo'] as any).toISOString();
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/genetics-reports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneticsReportsListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves genetics reports for a patient with search, sort, and filter capabilities
     * Get genetics reports by patient with search, sort, and filter
     */
    async getGeneticsReportsByPatient(requestParameters: GetGeneticsReportsByPatientRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneticsReportsListResponseDto> {
        const response = await this.getGeneticsReportsByPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves genetics reports for a patient by id
     * Get genetics reports by patient id
     */
    async getGeneticsReportsByPatientIdRaw(requestParameters: GetGeneticsReportsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneticsReportsListResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getGeneticsReportsByPatientId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['fileType'] != null) {
            queryParameters['fileType'] = requestParameters['fileType'];
        }

        if (requestParameters['uploadDateFrom'] != null) {
            queryParameters['uploadDateFrom'] = (requestParameters['uploadDateFrom'] as any).toISOString();
        }

        if (requestParameters['uploadDateTo'] != null) {
            queryParameters['uploadDateTo'] = (requestParameters['uploadDateTo'] as any).toISOString();
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/genetics-reports/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneticsReportsListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves genetics reports for a patient by id
     * Get genetics reports by patient id
     */
    async getGeneticsReportsByPatientId(requestParameters: GetGeneticsReportsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneticsReportsListResponseDto> {
        const response = await this.getGeneticsReportsByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a diagnostic (name, upload status, etc.)
     * Update diagnostic for provider
     */
    async updateDiagnosticForProviderRaw(requestParameters: UpdateDiagnosticForProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneticsReportResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling updateDiagnosticForProvider().'
            );
        }

        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling updateDiagnosticForProvider().'
            );
        }

        if (requestParameters['updateGeneticsReportRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateGeneticsReportRequestDto',
                'Required parameter "updateGeneticsReportRequestDto" was null or undefined when calling updateDiagnosticForProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/genetics-reports/{patientId}/{reportId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGeneticsReportRequestDtoToJSON(requestParameters['updateGeneticsReportRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneticsReportResponseDtoFromJSON(jsonValue));
    }

    /**
     * Updates a diagnostic (name, upload status, etc.)
     * Update diagnostic for provider
     */
    async updateDiagnosticForProvider(requestParameters: UpdateDiagnosticForProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneticsReportResponseDto> {
        const response = await this.updateDiagnosticForProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a genetics report (name, upload status, etc.)
     * Update genetics report
     */
    async updateGeneticsReportRaw(requestParameters: UpdateGeneticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneticsReportResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateGeneticsReport().'
            );
        }

        if (requestParameters['updateGeneticsReportRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateGeneticsReportRequestDto',
                'Required parameter "updateGeneticsReportRequestDto" was null or undefined when calling updateGeneticsReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/genetics-reports/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGeneticsReportRequestDtoToJSON(requestParameters['updateGeneticsReportRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneticsReportResponseDtoFromJSON(jsonValue));
    }

    /**
     * Updates a genetics report (name, upload status, etc.)
     * Update genetics report
     */
    async updateGeneticsReport(requestParameters: UpdateGeneticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneticsReportResponseDto> {
        const response = await this.updateGeneticsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Provider uploads a genetics report
     * Upload a genetics report
     */
    async uploadGeneticsReportRaw(requestParameters: UploadGeneticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GeneticsReportResponseDto>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling uploadGeneticsReport().'
            );
        }

        if (requestParameters['createGeneticsReportRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createGeneticsReportRequestDto',
                'Required parameter "createGeneticsReportRequestDto" was null or undefined when calling uploadGeneticsReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/genetics-reports/{patientId}/upload`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createGeneticsReportRequestDto']!.map(CreateGeneticsReportRequestDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GeneticsReportResponseDtoFromJSON));
    }

    /**
     * Provider uploads a genetics report
     * Upload a genetics report
     */
    async uploadGeneticsReport(requestParameters: UploadGeneticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GeneticsReportResponseDto>> {
        const response = await this.uploadGeneticsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetGeneticsReportsByPatientSortByEnum = {
    UploadedAt: 'uploadedAt',
    DocumentName: 'documentName',
    CreatedAt: 'createdAt'
} as const;
export type GetGeneticsReportsByPatientSortByEnum = typeof GetGeneticsReportsByPatientSortByEnum[keyof typeof GetGeneticsReportsByPatientSortByEnum];
/**
 * @export
 */
export const GetGeneticsReportsByPatientOrderByEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetGeneticsReportsByPatientOrderByEnum = typeof GetGeneticsReportsByPatientOrderByEnum[keyof typeof GetGeneticsReportsByPatientOrderByEnum];
/**
 * @export
 */
export const GetGeneticsReportsByPatientFileTypeEnum = {
    Pdf: 'pdf',
    Word: 'word',
    Image: 'image',
    Csv: 'csv'
} as const;
export type GetGeneticsReportsByPatientFileTypeEnum = typeof GetGeneticsReportsByPatientFileTypeEnum[keyof typeof GetGeneticsReportsByPatientFileTypeEnum];
/**
 * @export
 */
export const GetGeneticsReportsByPatientIdSortByEnum = {
    UploadedAt: 'uploadedAt',
    DocumentName: 'documentName',
    CreatedAt: 'createdAt'
} as const;
export type GetGeneticsReportsByPatientIdSortByEnum = typeof GetGeneticsReportsByPatientIdSortByEnum[keyof typeof GetGeneticsReportsByPatientIdSortByEnum];
/**
 * @export
 */
export const GetGeneticsReportsByPatientIdOrderByEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetGeneticsReportsByPatientIdOrderByEnum = typeof GetGeneticsReportsByPatientIdOrderByEnum[keyof typeof GetGeneticsReportsByPatientIdOrderByEnum];
/**
 * @export
 */
export const GetGeneticsReportsByPatientIdFileTypeEnum = {
    Pdf: 'pdf',
    Word: 'word',
    Image: 'image',
    Csv: 'csv'
} as const;
export type GetGeneticsReportsByPatientIdFileTypeEnum = typeof GetGeneticsReportsByPatientIdFileTypeEnum[keyof typeof GetGeneticsReportsByPatientIdFileTypeEnum];
